import TransitApi from './base'

export default {
  // Catálogo activo para el desplegable del formulario de facturas.
  async getActive() {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get('/transport-document/list')
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // ===== Administración del catálogo =====
  async getAll(params = {}) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(`/transport-document/all?${queryString}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async save(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const path = params.id
        ? `/transport-document/details/${params.id}`
        : '/transport-document/add'
      const result = await Api.post(path, params)
      return result
    } catch (error) {
      return error.response
    }
  },

  async delete(id) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.delete(`/transport-document/${id}`)
      return result
    } catch (error) {
      return error.response
    }
  },
}
